"use client";

import { motion, AnimatePresence } from "framer-motion";
import Lottie from "lottie-react";
import loaderAnimation from "../../../public/animation/loader-yellow.json";

type Props = {
	show: boolean;
	fullscreen?: boolean;
	bgColor?: string;
};

export default function LoadingScreen({
	show,
	fullscreen = false,
	bgColor = "#fff",
}: Props) {
	return (
		<AnimatePresence mode="wait">
			{show && (
				<motion.div
					key="loader"
					initial={{ opacity: 1 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.6 }}
					className={`${
						fullscreen
							? "fixed top-0 left-0 w-full h-screen z-50"
							: "relative w-full h-52 rounded-xl"
					} flex items-center justify-center`}
					style={{ backgroundColor: bgColor }}
				>
					<Lottie animationData={loaderAnimation} loop style={{ width: 350 }} />
				</motion.div>
			)}
		</AnimatePresence>
	);
}
